import { init as init$1, getConfig } from '@cian/config/browser';
import { AjaxTransport } from './internal/ajaxTransport.mjs';
import { TelemetryError } from '../shared/errors.mjs';
import { ETelemetryLoggerType } from '../shared/types.mjs';
import { generateTelemetryKey } from '../shared/internal/generateTelemetryKey.mjs';
import { ConsoleTransport } from '../shared/internal/transports/console.mjs';
import '../shared/internal/types.mjs';
import { TelemetryLogger } from '../shared/internal/telemetryLogger.mjs';

let telemetry;
let telemetrySettings;
const identity = (val) => val;
function setup(settings = {}) {
    const { keyTransformer = identity } = settings;
    telemetrySettings = {
        keyTransformer,
    };
}
const DEFAULT_STATSD_URL = 'http://master.browser-telemetry.dev3.cian.ru/public/v1/send-stats/';
const DEFAULT_STATSD_UPDATE_PERIOD = 5000;
/**
 * Публичная функция инициализации телеметрии
 * @returns {ITelemetryLogger}
 */
function init() {
    if (telemetry) {
        return telemetry;
    }
    if (!telemetrySettings) {
        throw new TelemetryError({
            message: 'Settings was not set for teletemetry. Forgot to call setup() before config initialization?',
            domain: 'browser#init()',
        });
    }
    const config = init$1();
    const projectName = config.getStrict('projectName');
    const prefix = `browser.microservice.${projectName}`;
    const keyTransformer = (key) => telemetrySettings.keyTransformer(generateTelemetryKey(prefix)(key));
    const transport = getTelemetryTransport();
    telemetry = new TelemetryLogger({
        transport,
        keyTransformer,
    });
    return telemetry;
}
function getTelemetryTransport() {
    const config = getConfig();
    const type = config.get('telemetry.browser.type') || ETelemetryLoggerType.STDOUT;
    if (type === ETelemetryLoggerType.STDOUT) {
        return new ConsoleTransport();
    }
    const url = config.get('telemetry.browser.url') || DEFAULT_STATSD_URL;
    const period = config.get('telemetry.browser.period') || DEFAULT_STATSD_UPDATE_PERIOD;
    return new AjaxTransport({ url, period });
}
/**
 * Публичная функция получения синглтона телеметрии
 * @returns {ITelemetryLogger}
 */
const getTelemetry = () => {
    if (!telemetry) {
        throw new Error('telemetry not initialized yet, call init function first');
    }
    return telemetry;
};

export { getTelemetry, init, setup };
//# sourceMappingURL=interface.mjs.map
